import type { QueryClient } from '@tanstack/react-query';

/**
 * Invalidate every query that reflects an estimate↔PO link, so both sides refresh
 * after a link/unlink: the PO detail + list and the estimate detail + list. These
 * keys are the query-key prefixes used by PurchaseOrderDetailPage / EstimateDetailPage
 * and the paginated list hooks (entity keys `purchase_orders` / `estimates`).
 */
export function invalidateEstimatePoLinkCaches(queryClient: QueryClient): void {
  for (const key of ['purchase-order', 'purchase_orders', 'estimate', 'estimates']) {
    queryClient.invalidateQueries({ queryKey: [key] });
  }
}
